/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IImageData } from '@msdyn365-commerce/core'; import * as React from 'react';


import { IMfrmAndroidBannerData } from './mfrm-android-banner.data';
import { IMfrmAndroidBannerProps } from './mfrm-android-banner.props.autogenerated';

export interface IMfrmAndroidBannerViewProps extends IMfrmAndroidBannerProps<IMfrmAndroidBannerData> {
    image: IImageData;
    appName: string;
    companyName: string;
    body?: string;
    ctaName?: string;
    remindTime?: number;
    manifest: string;
    starRatings: IImageData;
}

/**
 *
 * MfrmAndroidBanner component
 * @extends {React.PureComponent<IMfrmAndroidBannerProps<IMfrmAndroidBannerData>>}
 */
class MfrmAndroidBanner extends React.PureComponent<IMfrmAndroidBannerProps<IMfrmAndroidBannerData>> {
    public render(): JSX.Element | null {
        const { image, appName, companyName, body, ctaName, remindTime, manifest, starRatings } = this.props.config;
        const androidAppProps = {
            ...this.props,
            image,
            appName,
            companyName,
            body,
            ctaName,
            remindTime,
            manifest,
            starRatings
        };
        return this.props.renderView(androidAppProps);
    }
}

export default MfrmAndroidBanner;
